import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = false;

  actualUser: string;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute) {
    console.log("url" + window.location.search);
  }

  ngOnInit() {
   this._route.queryParamMap.subscribe(queryParams => {
     this.actualUser = queryParams.get("userPrincipal");
     console.log("userPrincipal:" + this.actualUser);
    })
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
